import { Button, Modal } from "antd";
import  { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import axios from "axios";
import {  dispatchtoast, getLocalStorageItem } from "../../../../Utils";
import { Globalendpoints } from "../../../../ApiServices/global";
import { getEkoQrCode } from "../EkoEndpoint";
import { APIURL } from "../../../../ApiServices/Axios";

const EkoQrModal = ({ openModal, setopenModal, qrData = {},apiCall={} }) => {
  const [amount, setamount] = useState(null);
  const [btnDisable, setBtnDisable] = useState(false);
  const [QrLink, setQrLink] = useState("");
  const [transaction_id, setTransactionId] = useState(null);
  const [timer, setTimer] = useState(60);
  const [btnLoading, setBtnLoading] = useState(false);
  const handleGenerate = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("amount", amount);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    getEkoQrCode(formdata)
      .then((res) => {
        if (res.status) {
          setBtnDisable(true);
          setQrLink(res.request_data.payment_data.data.qr_string);
          setTransactionId(res.data.transaction_id);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handlecheckStatus = (apiinterval) => {
    const formdata = new FormData();
    formdata.append("transaction_id", transaction_id);
    axios
      .post(APIURL + Globalendpoints.checkUpiPaymentstatus, formdata, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          dispatchtoast(res.data.message);
          clearInterval(apiinterval);
          setopenModal(false);
          apiCall()
        }
      });
  };
  useEffect(() => {
    if (qrData) {
      setQrLink(qrData.link);
      setTransactionId(qrData.transactionId);
    }
  }, []);
//   useEffect(() => {
//     let a = 60;
//     let interval;
//     let apiInterval;
//     let count = 0;
//     if (QrLink) {
//       interval = setInterval(() => {
//         a = a - 1;
//         if (a === 0) {
//           clearInterval(interval);
//         }
//         setTimer(a);
//       }, 1000);
//       apiInterval = setInterval(() => {
//         count = count + 1;
//         if (count === 6) {
//           clearInterval(apiInterval);
//           setopenModal(false);
//           apiCall()
//         }
//         handlecheckStatus(apiInterval);
//       }, 10000);
//     }
//     return () => {
//       clearInterval(apiInterval);
//       clearInterval(interval);
//     };
//   }, [QrLink]);
  return (
    <Modal
      maskClosable={false}
      title="Qr Code"
      width={400}
      footer={null}
      open={openModal}
      onCancel={() => {
        setopenModal(false);
        apiCall()
      }}
    >
      {!qrData && (
        <div className="amount mt-4  font-bold text-center">
          <p className="text-3xl">₹</p>
          <input
            onChange={(e) => setamount(e.target.value)}
            value={amount}
            onInput={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              e.target.value = value;
            }}
            placeholder="0"
            className="border-none mb-5 text-lg text-center"
          />
        </div>
      )}
      {QrLink && (
        <p className="text-center font-semibold mb-2 text-red-500">
          {/* Close in: 00:{timer} */}
        </p>
      )}
      {QrLink && (
        <div className="flex justify-center mb-5 items-center">
          <QRCodeCanvas
            id="qrCode"
            value={QrLink}
            size={200}
            bgColor={"#ffffff"}
            level={"H"}
          />
        </div>
      )}
      {!qrData && (
        <Button
          loading={btnLoading}
          onClick={handleGenerate}
          disabled={!amount || btnDisable}
          className="bg-primary border-none text-white w-full"
        >
          Generate Qr
        </Button>
      )}
    </Modal>
  );
};

export default EkoQrModal;
